<template>
    <div class="featured-tyres col-12 mb-3">
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-2 row-cols-xxl-1 g-3 g-xxl-0">
            <div v-for="tyre in featuredTyres" class="col" :key="tyre.id">
                <featured-tyre
                    :featured="true"
                    :tyre="tyre"
                    :banners="banners"
                    :postcode="postcode"
                    @modalOpen="modelOpen()"
                    @basketUpdated="basketUpdated"
                ></featured-tyre>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['basket', 'banners', 'featuredTyres', 'postcode'],
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {
            modelOpen() {
                this.$emit('modalOpen');
            },
            basketUpdated: function(data) {
                this.$emit('basket-updated', data);
            }
        },
        computed: {
            
        }
    }
</script>
<style lang="scss" scoped>
    .col {
        .featured-tyre {
            border: 2px solid #0064EF !important;
            border-bottom: 0 !important;
            border-radius: 0;
        }
        &:first-of-type {
            .featured-tyre {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
            }
        }
        &:last-of-type {
            .featured-tyre {
                border-bottom: 2px solid #0064EF !important;
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
            }
        }
    }
</style>